class VideoBackgroundVimeo extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.render();
        window.addEventListener("resize", this.updateVideo.bind(this));
    }

    connectedCallback() {
        this.desktopVideoId = this.getAttribute("desktop-src");
        this.mobileVideoId = this.getAttribute("mobile-src");
        this.updateVideo();
    }

    render() {
        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    display: block;
                    position: relative;
                    width: 100%;
                }

                .video-wrapper {
                    width: 100%;
                    height: 0;
                    position: relative;
                    padding-top: 56.25%; /* default 16:9 */
                }

                iframe {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border: none;
                    pointer-events: none;
                }
            </style>
            <div class="video-wrapper" id="video-container-vimeo"></div>
        `;
    }

    updateVideo() {
        const container = this.shadowRoot.getElementById(
            "video-container-vimeo"
        );
        const isMobile = window.innerWidth < 750;

        const videoId = isMobile ? this.mobileVideoId : this.desktopVideoId;
        const videoSrc = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&muted=1&controls=0`;

        const existingIframe = container.querySelector("iframe");
        if (existingIframe && existingIframe.src === videoSrc) {
            return;
        }

        const wrapper = this.shadowRoot.querySelector(".video-wrapper");
        if (wrapper) {
            wrapper.style.paddingTop = isMobile ? "177.77%" : "56.25%";
        }

        container.innerHTML = `
            <iframe
                src="${videoSrc}"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen
                data-host="vimeo">
            </iframe>
        `;
    }
}

customElements.define("video-background-vimeo", VideoBackgroundVimeo);
